<template>
  <div class="submenu-padding sub-box scroll-person">
    <div class="box-header no-padding--top">
      <div class="box-title">{{ $t('edit.sidebar.choose_a_theme') }}</div>
    </div>
    <div
      v-for="theme in themeList"
      class="kp-modular-row clearfix"
      :class="{ select: theme.slug === themeActive.slug }">
      <a @click="changeTheme(theme)">
        <div class="media-hover">
          <div class="theme_select">
            <i class="icon-kp-check"></i>
            <a
              href="#"
              class="btn btn--inline"
              @click="sidebarChangePanel('style');sidebarChangeActiveButton('style');">{{ $t('edit.sidebar.edit_theme') }}</a>
          </div>
        </div>
        <img class="media-image" :src="thumbUrl(theme.slug)" :alt="theme.name">
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import rebrand from '../../../../config/rebrand';
import HighlightHelper from '../../../../helpers/highlight';

const highlightHelper = new HighlightHelper();

export default {
  data() {
    return {
      themeUrl: rebrand.urls.THEME_CDN_URI,
    };
  },
  computed: mapGetters({
    themeList: 'themeList',
    themeActive: 'themeActive',
  }),
  methods: {
    thumbUrl(slug) {
      return `${this.themeUrl}/themes/${slug}/thumb.jpg`;
    },
    changeTheme(theme) {
      this.canvasDisableHighlight();
      this.themeSetActive(theme);
      this.themeUpdateStyles(theme);

      const actions = {
        sidebarChangePanel: this.sidebarChangePanel,
        sidebarSetElement: this.sidebarSetElement,
        canvasEnableHighlight: this.canvasEnableHighlight,
        sidebarChangeActiveButton: this.sidebarChangeActiveButton,
      };

      highlightHelper.bind(actions);
    },
    ...mapActions([
      'themeSetActive',
      'themeUpdateStyles',
      'sidebarChangePanel',
      'sidebarSetElement',
      'canvasEnableHighlight',
      'canvasDisableHighlight',
      'sidebarChangeActiveButton',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** List.vue?cd314e2c
 **/